import React from 'react';
import { motion } from 'framer-motion';
import { LinkIcon, ClockIcon, XIcon } from 'lucide-react';
interface BulkActionBarProps {
  selectedCount: number;
  onLink: () => void;
  onSkip: () => void;
  onClear: () => void;
}
const BulkActionBar = ({
  selectedCount,
  onLink,
  onSkip,
  onClear
}: BulkActionBarProps) => {
  if (selectedCount === 0) return null;
  return <motion.div initial={{
    y: 100,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} exit={{
    y: 100,
    opacity: 0
  }} className="fixed bottom-0 left-0 right-0 p-4 z-40" data-id="element-13">
      <div className="max-w-7xl mx-auto" data-id="element-14">
        <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-4 flex items-center justify-between" data-id="element-15">
          <div className="flex items-center space-x-3" data-id="element-16">
            <div className="h-10 w-10 rounded-full bg-blue-50 flex items-center justify-center" data-id="element-17">
              <span className="text-blue-600 font-semibold" data-id="element-18">
                {selectedCount}
              </span>
            </div>
            <p className="font-medium text-gray-900" data-id="element-19">
              {selectedCount} {selectedCount === 1 ? 'Product' : 'Products'}{' '}
              Selected
            </p>
          </div>
          <div className="flex items-center space-x-3" data-id="element-20">
            <button onClick={onClear} className="px-3 py-1.5 text-sm text-gray-600 hover:text-gray-900 flex items-center" data-id="element-21">
              <XIcon className="h-4 w-4 mr-1" data-id="element-22" />
              Clear Selection
            </button>
            <button onClick={onSkip} className="px-3 py-1.5 text-sm text-gray-600 hover:text-gray-900 flex items-center" data-id="element-23">
              <ClockIcon className="h-4 w-4 mr-1" data-id="element-24" />
              Skip Selected
            </button>
            <motion.button onClick={onLink} className="bg-blue-600 text-white px-4 py-2 rounded-md flex items-center font-medium hover:bg-blue-700" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} data-id="element-25">
              <LinkIcon className="h-4 w-4 mr-1" data-id="element-26" />
              Link Selected
            </motion.button>
          </div>
        </div>
      </div>
    </motion.div>;
};
export default BulkActionBar;